import { Typography } from '@mui/material'
import type { ReactNode } from 'react'

type PreviewCardTitleProps = {
  children: ReactNode
  /** Collapses to one line with an ellipsis. */
  noWrap?: boolean
}

// Titles are often filenames or reference numbers with no spaces to break on, and the card is
// only 320–450px wide, so an unbroken title would otherwise overflow the surface.
export const PreviewCardTitle = ({ children, noWrap }: PreviewCardTitleProps) => (
  <Typography variant="display-h4" noWrap={noWrap} sx={{ wordBreak: 'break-word' }}>
    {children}
  </Typography>
)

export const PreviewCardSubtitle = ({ children, noWrap }: PreviewCardTitleProps) => (
  <Typography variant="small-regular" color="text.muted" noWrap={noWrap}>
    {children}
  </Typography>
)
